module.exports = __webpack_public_path__ + "img/empty-state-invoices.ba3b545e.png";